/* Yek Pharma — dönüşüm katmanı (9 Ekim 2026)
   Duyuru şeridi hızı, header gölgesi, ürün sayfası (kutu seçici, düğmede toplam, yapışkan çubuk, yanına ekleyin,
   müşteri yorumları), sepet çekmecesi (öneri ekleme, +1 kutu).
   İndirim kuralı mağazadaki otomatik indirimlerle aynıdır (2 ürün 200 TL, 3 ürün 500 TL, 5.000 TL+ 1.000 TL; en yükseği). */
(function () {
  'use strict';

  // adet: kampanyalı (1.000 TL ve üzeri) ürün adedi; araToplam: sepetin indirimsiz tutarı
  var YK_INDIRIM = function (adet, araToplam) {
    var d = 0;
    if (adet >= 2) d = 20000;
    if (adet >= 3) d = 50000;
    if (araToplam >= 500000) d = 100000;
    return d;
  };
  var tl = function (kurus) {
    return Math.round(kurus / 100).toLocaleString('tr-TR') + ' TL';
  };
  var hazir = function (fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  };

  /* ---------- Duyuru şeridi: sabit, sakin hız (px/sn) ---------- */
  function seritHizi() {
    document.querySelectorAll('.shopify-section-group-header-group marquee-scroll-bar').forEach(function (bar) {
      var oge = bar.querySelector('.scrolling--item');
      if (!oge) return;
      var genislik = oge.getBoundingClientRect().width;
      if (!genislik) return;
      var sure = Math.max(30, genislik / 34);
      bar.querySelectorAll('.scrolling--item').forEach(function (x) { x.style.animationDuration = sure.toFixed(1) + 's'; });
    });
  }

  /* ---------- Header gölgesi ---------- */
  function headerGolge() {
    var kok = document.documentElement, acik = false;
    var kontrol = function () {
      var yeni = window.scrollY > 40;
      if (yeni !== acik) { acik = yeni; kok.classList.toggle('yk-header-golge', acik); }
    };
    window.addEventListener('scroll', kontrol, { passive: true });
    kontrol();
  }
  function headerYuksekligi() {
    var h = document.querySelector('.shopify-section-group-header-group[id$="__header"]');
    return h ? h.offsetHeight : 0;
  }

  /* ---------- Sepet: ekle / değiştir ve çekmeceyi yenile ---------- */
  function cekmece() {
    var c = document.querySelector('cart-notification');
    return c && typeof c.renderContents === 'function' ? c : null;
  }
  function sepetIstek(url, govde) {
    var c = cekmece();
    if (c) {
      govde.sections = c.getSectionsToRender().map(function (s) { return s.id; });
      govde.sections_url = window.location.pathname;
    }
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(govde)
    }).then(function (r) { return r.json(); }).then(function (veri) {
      if (veri && veri.status && veri.description) throw new Error(veri.description);
      if (c && veri.sections && !/^\/cart\/?$/.test(window.location.pathname)) {
        c.renderContents(veri);
        try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'yek', cartData: veri }); } catch (err) {}
      } else {
        window.location.reload();
      }
      return veri;
    });
  }
  function bekle(btn, yazi) {
    btn.disabled = true;
    btn.dataset.ykEski = btn.innerHTML;
    btn.textContent = yazi || 'Ekleniyor…';
  }
  function birak(btn, hata) {
    btn.disabled = false;
    btn.innerHTML = btn.dataset.ykEski || btn.innerHTML;
    if (hata) { btn.textContent = 'Eklenemedi'; setTimeout(function () { btn.innerHTML = btn.dataset.ykEski; }, 2200); }
  }
  document.addEventListener('click', function (e) {
    var ekle = e.target.closest('[data-yk-ekle]');
    if (ekle) {
      e.preventDefault();
      bekle(ekle);
      sepetIstek('/cart/add.js', { items: [{ id: Number(ekle.getAttribute('data-yk-ekle')), quantity: 1 }] })
        .catch(function () { birak(ekle, true); });
      return;
    }
    var arti = e.target.closest('[data-yk-arttir-satir]');
    if (arti) {
      e.preventDefault();
      bekle(arti);
      sepetIstek('/cart/change.js', { line: Number(arti.getAttribute('data-yk-arttir-satir')), quantity: Number(arti.getAttribute('data-adet')) })
        .catch(function () { birak(arti, true); });
      return;
    }
    var yorum = e.target.closest('[data-yk-yorumlara]');
    if (yorum) {
      var hedef = document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-review-widget');
      if (!hedef) return;
      e.preventDefault();
      window.scrollTo({ top: hedef.getBoundingClientRect().top + window.pageYOffset - headerYuksekligi() - 16, behavior: 'smooth' });
    }
  });

  /* ---------- Ürün sayfası ---------- */
  function urunSayfasi() {
    var kok = document.querySelector('[data-yk-urun]');
    if (!kok) return;
    var bolum = kok.closest('.product-section') || kok.closest('section') || document;
    var fiyat = parseInt(kok.getAttribute('data-fiyat'), 10) || 0;
    var anaForm = bolum.querySelector('.product_buy_button_form');
    var anaAdet = anaForm ? anaForm.querySelector('input[name="quantity"]') : null;
    if (!anaAdet) anaAdet = bolum.querySelector('input[name="quantity"]');
    var anaDugme = anaForm ? anaForm.querySelector('.product-form__submit') : null;
    var kartlar = kok.querySelectorAll('.yk-kutu__kart');
    var yap = document.querySelector('[data-yk-yapiskan]');
    var cipler = yap ? yap.querySelectorAll('.yk-yapiskan__cip') : [];
    var yapAdet = yap ? yap.querySelector('[data-yk-yapiskan-adet]') : null;
    var yapTutar = yap ? yap.querySelector('[data-yk-yapiskan-tutar]') : null;
    var birlikte = document.querySelector('[data-yk-birlikte]');
    var fazla = kok.querySelector('[data-yk-fazla]');
    var fazlaAdet = fazla ? fazla.querySelector('[data-yk-fazla-adet]') : null;
    var fazlaMetin = fazla ? fazla.querySelector('[data-yk-fazla-metin]') : null;

    var kampanya = kok.getAttribute('data-kampanya') === '1';
    var tutar = function (q) { var ham = fiyat * q; return ham - YK_INDIRIM(kampanya ? q : 0, ham); };

    // Sepete Ekle düğmesinde toplam
    var anaTutar = null;
    if (anaDugme && fiyat && !anaDugme.disabled) {
      anaTutar = document.createElement('span');
      anaTutar.className = 'yk-dugme-tutar';
      anaDugme.appendChild(anaTutar);
    }

    var guncel = 1;
    function uygula(q, kaynak) {
      q = Math.max(1, parseInt(q, 10) || 1);
      guncel = q;
      kartlar.forEach(function (k) { k.setAttribute('aria-checked', String(parseInt(k.getAttribute('data-yk-adet'), 10) === q)); });
      cipler.forEach(function (k) { k.setAttribute('aria-checked', String(parseInt(k.getAttribute('data-yk-adet'), 10) === q)); });
      if (anaTutar) anaTutar.textContent = tl(tutar(q));
      if (yapTutar) yapTutar.textContent = tl(tutar(q));
      if (yapAdet && kaynak !== 'yapiskan') yapAdet.value = q;
      // 4 ve üzeri kutu: kartların altındaki adım satırı seçili olur, toplam indirimle yazılır
      if (fazla) {
        if (fazlaAdet && kaynak !== 'fazla') fazlaAdet.value = q;
        fazla.classList.toggle('secili', q > 3);
        if (fazlaMetin) fazlaMetin.innerHTML = q > 3 ? '<strong>' + q + ' kutu</strong> · ' + tl(tutar(q)) + (fiyat * q > tutar(q) ? ' <em>' + tl(fiyat * q - tutar(q)) + ' tasarruf</em>' : '') : 'Daha fazla kutu mu lazım?';
      }
      if (anaAdet && kaynak !== 'ana' && String(anaAdet.value) !== String(q)) {
        anaAdet.value = q;
        anaAdet.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (birlikte) {
        var esF = parseInt(birlikte.getAttribute('data-es-fiyat'), 10) || 0;
        var ham = fiyat * q + esF;
        var t = birlikte.querySelector('[data-yk-birlikte-toplam]');
        var esK = birlikte.getAttribute('data-es-kampanya') === '1';
        var bInd = YK_INDIRIM((kampanya ? q : 0) + (esK ? 1 : 0), ham);
        if (t) t.textContent = tl(ham - bInd);
        var eski = t && t.nextElementSibling;
        if (eski && eski.tagName === 'S') { eski.textContent = tl(ham); eski.hidden = bInd === 0; }
        var bi = birlikte.querySelector('[data-yk-birlikte-ind]');
        if (bi) { bi.textContent = 'Sepette ' + tl(bInd) + ' indirim'; bi.hidden = bInd === 0; }
      }
    }
    kartlar.forEach(function (k) {
      k.addEventListener('click', function () { uygula(k.getAttribute('data-yk-adet'), 'kart'); });
    });
    cipler.forEach(function (k) {
      k.addEventListener('click', function () { uygula(k.getAttribute('data-yk-adet'), 'cip'); });
    });
    if (fazla) {
      fazla.querySelector('[data-yk-fazla-azalt]').addEventListener('click', function () { uygula(guncel - 1); });
      fazla.querySelector('[data-yk-fazla-arttir]').addEventListener('click', function () { uygula(guncel < 4 ? 4 : guncel + 1); });
      if (fazlaAdet) fazlaAdet.addEventListener('change', function () { uygula(Math.min(99, parseInt(fazlaAdet.value, 10) || 1), 'fazla'); });
    }
    if (anaAdet) {
      ['change', 'input'].forEach(function (ev) {
        anaAdet.addEventListener(ev, function () { if (parseInt(anaAdet.value, 10) !== guncel) uygula(anaAdet.value, 'ana'); });
      });
    }
    if (yap) {
      var az = yap.querySelector('[data-yk-azalt]'), ar = yap.querySelector('[data-yk-arttir]');
      if (az) az.addEventListener('click', function () { uygula(guncel - 1); });
      if (ar) ar.addEventListener('click', function () { uygula(guncel + 1); });
      if (yapAdet && yapAdet.type === 'number') yapAdet.addEventListener('change', function () { uygula(yapAdet.value, 'yapiskan'); });
    }
    uygula(anaAdet ? anaAdet.value : 1, 'ana');

    // Yapışkan çubuk: sayfadaki Sepete Ekle düğmesi ekranın üstünden çıkınca açılır
    if (yap && anaForm) {
      var tek = !cipler.length, acikMi = null, bekliyor = false;
      var kontrolEt = function () {
        bekliyor = false;
        var goster = anaForm.getBoundingClientRect().bottom < 0;
        if (goster === acikMi) return;
        acikMi = goster;
        yap.classList.toggle('acik', goster);
        document.body.classList.toggle('yk-yapiskan-acik', goster);
        document.body.classList.toggle('yk-yapiskan-tek', goster && tek);
      };
      var iste = function () { if (!bekliyor) { bekliyor = true; requestAnimationFrame(kontrolEt); } };
      window.addEventListener('scroll', iste, { passive: true });
      window.addEventListener('resize', iste);
      kontrolEt();
    }

    // Yanına ekleyin: ana ürün (seçili adet) + eş ürün tek seferde
    if (birlikte) {
      var bd = birlikte.querySelector('[data-yk-birlikte-ekle]');
      bd.addEventListener('click', function () {
        bekle(bd);
        sepetIstek('/cart/add.js', {
          items: [
            { id: Number(birlikte.getAttribute('data-ana')), quantity: guncel },
            { id: Number(birlikte.getAttribute('data-es')), quantity: 1 }
          ]
        }).then(function () { birak(bd); }).catch(function () { birak(bd, true); });
      });
    }

    // Tahmini teslim tarihi (kargo politikası: 2-5 iş günü; hafta sonu sayılmaz)
    var teslim = kok.querySelector('[data-yk-teslim] span');
    if (teslim) {
      var isGunu = function (n) {
        var d = new Date();
        while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
        return d;
      };
      var aylar = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
      var d1 = isGunu(2), d2 = isGunu(5);
      var aralik = d1.getMonth() === d2.getMonth()
        ? d1.getDate() + '–' + d2.getDate() + ' ' + aylar[d2.getMonth()]
        : d1.getDate() + ' ' + aylar[d1.getMonth()] + ' – ' + d2.getDate() + ' ' + aylar[d2.getMonth()];
      teslim.innerHTML = 'Ücretsiz kargo · Tahmini teslim <b>' + aralik + '</b>';
    }

    // Aynı gün kargo geri sayımı (Duygu Hanım 9 Eki: hafta içi 16:30'a kadar gelen sipariş aynı gün çıkar).
    // Saat ziyaretçinin cihazına göre değil Türkiye saatine (UTC+3) göre hesaplanır; resmi tatiller TATIL listesine eklenir.
    var kargo = kok.querySelector('[data-yk-kargo]');
    if (kargo) {
      var TATIL = ['2026-10-29', '2027-01-01'];
      var gunAd = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
      var kBaslik = kargo.querySelector('[data-yk-kargo-baslik]');
      var kAlt = kargo.querySelector('[data-yk-kargo-alt]');
      var kSayac = kargo.querySelector('[data-yk-kargo-sayac]');
      var iki = function (n) { return (n < 10 ? '0' : '') + n; };
      var kargoGunu = function (d) {
        var g = d.getUTCDay();
        return g !== 0 && g !== 6 && TATIL.indexOf(d.toISOString().slice(0, 10)) < 0;
      };
      var kargoYaz = function () {
        var t = new Date(Date.now() + 3 * 3600 * 1000);
        var kalan = 16 * 3600 + 30 * 60 - (t.getUTCHours() * 3600 + t.getUTCMinutes() * 60 + t.getUTCSeconds());
        if (kargoGunu(t) && kalan > 0) {
          kargo.classList.add('is-bugun');
          kBaslik.textContent = 'Bugün kargoda';
          kAlt.textContent = "16:30'a kadar sipariş verin, bugün kargoya verilsin";
          kSayac.textContent = iki(Math.floor(kalan / 3600)) + ':' + iki(Math.floor(kalan % 3600 / 60)) + ':' + iki(kalan % 60);
          kSayac.hidden = false;
          return;
        }
        var d = new Date(t.getTime()), n = 0;
        do { d.setUTCDate(d.getUTCDate() + 1); n++; } while (!kargoGunu(d));
        kargo.classList.remove('is-bugun');
        kBaslik.textContent = (n === 1 ? 'Yarın' : gunAd[d.getUTCDay()]) + ' kargoda';
        kAlt.textContent = 'Şimdi sipariş verin, ' + (n === 1 ? 'yarın' : gunAd[d.getUTCDay()]) + ' ilk iş kargoya verilsin';
        kSayac.hidden = true;
      };
      kargoYaz();
      setInterval(kargoYaz, 1000);
    }

    // Bakanlık onay numarası açıklamada yazıyorsa güven listesine
    var liste = kok.querySelector('.yk-guven__liste');
    var desc = bolum.querySelector('.product__description');
    var m = desc && (desc.textContent || '').match(/Onay Numaras[ıi]\s*:?\s*([0-9]{4,}[-.0-9]*)/);
    if (liste && m) {
      var d = document.createElement('div');
      d.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M7 9h10M7 13h6"/></svg><span><span class="yk-soluk">Tarım ve Orman Bakanlığı onay no:</span> ' + m[1] + '</span>';
      liste.appendChild(d);
    }

    // Müşteriler ne diyor: sayfadaki gerçek Judge.me yorumlarından 3 tanesi.
    // Judge.me yorumları sonradan çizdiği için hazır olana kadar (en fazla ~12 sn) beklenir.
    var yorumKutu = document.querySelector('[data-yk-yorum]');
    if (yorumKutu) {
      var hedefListe = yorumKutu.querySelector('[data-yk-yorum-liste]');
      // Sağlık sonucu anlatan yorumlar silinmez/gizlenmez (Judge.me'de duruyor); burada yalnız öne çıkarma sırası düşer.
      var iddia = /a[ğg]r[ıi]|tedavi|iyile[şs]|azald|ge[çc]ti|hastal|romatizma|fibromiyalji|kire[çc]|f[ıi]t[ıi]k|doktor|dr\b/i;
      var topla = function () {
        var adaylar = [];
        document.querySelectorAll('#judgeme_product_reviews .jm-review-item').forEach(function (it) {
          var st = it.querySelector('.jm-star-rating');
          var m2 = st && (st.getAttribute('aria-label') || '').match(/(\d)/);
          var govde = it.querySelector('.jdgm-review-content__body-content, .jm-review-content__body');
          adaylar.push({ puan: m2 ? parseInt(m2[1], 10) : 0, metin: govde ? govde.textContent : '', kim: (it.querySelector('.jm-reviewer-info__name') || {}).textContent || '' });
        });
        if (!adaylar.length) {
          document.querySelectorAll('#judgeme_product_reviews .jdgm-rev').forEach(function (r) {
            var pe = r.querySelector('.jdgm-rev__rating');
            adaylar.push({ puan: pe ? parseInt(pe.getAttribute('data-score'), 10) : 0, metin: (r.querySelector('.jdgm-rev__body') || {}).textContent || '', kim: (r.querySelector('.jdgm-rev__author') || {}).textContent || '' });
          });
        }
        return adaylar.map(function (a) { a.metin = a.metin.replace(/\s+/g, ' ').trim(); a.kim = a.kim.trim(); return a; })
          .filter(function (a) { return a.puan >= 4 && a.metin.length >= 25; });
      };
      var puanla = function (a) { return (a.puan === 5 ? 4 : 0) + (iddia.test(a.metin) ? 0 : 3) + (a.metin.length > 40 && a.metin.length < 240 ? 1 : 0); };
      var bas = function (adaylar) {
        adaylar.sort(function (a, b) { return puanla(b) - puanla(a); });
        adaylar.slice(0, 3).forEach(function (a) {
          var kart = document.createElement('div');
          kart.className = 'yk-yorum__kart';
          var y = document.createElement('span');
          y.className = 'yk-yildiz yk-yildiz--k';
          y.setAttribute('aria-label', a.puan + ' yıldız');
          y.textContent = '★★★★★'.slice(0, a.puan) + '☆☆☆☆☆'.slice(0, 5 - a.puan);
          var p = document.createElement('p');
          p.className = 'yk-yorum__metin';
          p.textContent = '“' + a.metin + '”';
          var k = document.createElement('div');
          k.className = 'yk-yorum__kim';
          k.textContent = a.kim.replace(/\*{2,}/g, '***');
          kart.appendChild(y); kart.appendChild(p); kart.appendChild(k);
          hedefListe.appendChild(kart);
        });
        yorumKutu.hidden = false;
      };
      var deneme = 0;
      var bekleYorum = function () {
        var a = topla();
        if (a.length) return bas(a);
        if (++deneme < 24) setTimeout(bekleYorum, 500);
      };
      bekleYorum();
    }
  }

  /* ---------- Clarity huni olayları (12 Ekim 2026) ----------
     Clarity'nin düğme metniyle eşleşen akıllı etkinliği yeni temada saymıyordu ("Ödeme yap" ≠ "Ödeme Yap",
     Sepete Ekle düğmesinde fiyat yazısı var). Olaylar adla gönderilir; Clarity'de "sepete_ekle" ve "odeme_gecis"
     özel (API) etkinlikleri ve "Satis hunisi" bunlara bağlıdır. Clarity yüklenmemişse çağrı kuyrukta bekler. */
  function clarityOlaylari() {
    window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
    var son = {};
    var gonder = function (ad) {
      var simdi = Date.now();
      if (son[ad] && simdi - son[ad] < 1500) return;
      son[ad] = simdi;
      try { window.clarity('event', ad); } catch (e) {}
    };
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target : e.target.parentElement;
      if (!t) return;
      if (t.closest('[name="add"], .yk-kart__dugme, [data-yk-birlikte-ekle], [data-yk-ekle], [data-yk-arttir-satir]')) gonder('sepete_ekle');
      else if (t.closest('[name="checkout"], a[href*="/checkout"]')) gonder('odeme_gecis');
    }, true);
  }

  /* ---------- Sepet sayfası mobil ödeme çubuğu (12 Ekim 2026) ----------
     Sayfadaki Ödeme Yap düğmesi ekranda değilken altta sabit "Toplam + Ödeme Yap" çubuğu görünür.
     Çubuk main-cart-footer ile yeniden çizildiği için her kontrolde yeniden aranır. */
  function sepetCubugu() {
    if (!document.getElementById('main-cart-footer')) return;
    var bekliyor = false;
    var kontrol = function () {
      bekliyor = false;
      var cubuk = document.querySelector('[data-yk-sepet-cubuk]');
      var asil = document.querySelector('.cart__checkout-button');
      var goster = false;
      if (cubuk && asil && window.innerWidth < 750) {
        var r = asil.getBoundingClientRect();
        goster = r.top > window.innerHeight - 20 || r.bottom < 0;
      }
      if (cubuk) cubuk.classList.toggle('acik', goster);
      document.body.classList.toggle('yk-sepet-cubuk-acik', goster);
    };
    var iste = function () { if (!bekliyor) { bekliyor = true; requestAnimationFrame(kontrol); } };
    window.addEventListener('scroll', iste, { passive: true });
    window.addEventListener('resize', iste);
    new MutationObserver(iste).observe(document.getElementById('main-cart-footer'), { childList: true, subtree: true });
    kontrol();
  }

  hazir(function () {
    clarityOlaylari();
    sepetCubugu();
    headerGolge();
    urunSayfasi();
    requestAnimationFrame(seritHizi);
    window.addEventListener('load', seritHizi);
    var gen = window.innerWidth;
    window.addEventListener('resize', function () { if (Math.abs(window.innerWidth - gen) > 40) { gen = window.innerWidth; seritHizi(); } });
  });
})();
